import 'leaflet';
import 'leaflet-geometryutil';
import '../components/Map/Extensions/FillPattern';

import 'leaflet/dist/leaflet.css';

import * as MapPages from '../components/mapComponents';
import '../styles/mapinterface/map.scss';

const MapComponents = { ...MapPages };

global['MapComponents'] = MapComponents;
export { MapComponents };
